import React from 'react';
import {Drawer, Space, Spin} from 'antd';
import {CloseOutlined} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';
import {PodExemptReportDetailType} from '../../graphql/podExempt/types';
import PodExemptStatusTag from './PodExemptStatusTag';
import PodExemptDetailContent from './PodExemptDetailContent';

interface Props {
  open: boolean;
  onClose: () => void;
  detail: PodExemptReportDetailType | null;
  loading: boolean;
  /** 底部操作区（DSP=关闭等），各端注入 */
  actions?: React.ReactNode;
  /** 附加内容（如 500m 参考地图），渲染在时间线之前 */
  extra?: React.ReactNode;
  /** 展示数据参考面板（单量/客诉/识别率等，监控侧接入前显示待接入） */
  showDataPanel?: boolean;
  dictNameOf?: (code: string) => string;
}

/** 上报详情抽屉（正文复用 PodExemptDetailContent，与审核页同一套展示）。 */
const PodExemptDetailDrawer: React.FC<Props> = ({
  open,
  onClose,
  detail,
  loading,
  actions,
  extra,
  showDataPanel = false,
  dictNameOf,
}) => {
  const {t} = useTranslation();

  return (
    <Drawer
      open={open}
      onClose={onClose}
      width={920}
      // 地图实例随抽屉销毁重建：否则复用旧实例，用户挪动过的视野会被记住，二次打开看不到围栏
      destroyOnClose
      closable={false}
      // 正文为审核页同款白卡分区，灰底衬托卡片边界
      styles={{body: {background: '#f5f5f5'}}}
      title={
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <span className="h-5 border-l-4 border-purple-500 mt-1" />
            <span className="text-xl font-medium text-black">
              {detail ? detail.report.reportNo : t('podExempt.detail.title')}
            </span>
            {detail && <PodExemptStatusTag status={detail.report.status} />}
          </div>
          <CloseOutlined onClick={onClose} className="cursor-pointer" />
        </div>
      }
      footer={actions ? <Space>{actions}</Space> : undefined}
    >
      {loading || !detail ? (
        <Spin />
      ) : (
        <PodExemptDetailContent
          detail={detail}
          extra={extra}
          showDataPanel={showDataPanel}
          dictNameOf={dictNameOf}
        />
      )}
    </Drawer>
  );
};

export default PodExemptDetailDrawer;
